export default {
  ai: {
    k_001001: 'API undefined',
    k_001002:
      'System upgrade in progress from 00:00 to 07:00. We apologize for any inconvenience caused!',
    k_002001: 'Token parameter missing',
    k_002002: 'API request exception',
    k_002003: 'Failed to request information',
    k_002004: 'Failed to parse user information',
    k_002005: 'Failed to get information',
    k_003001: 'AI Basics',
    k_003002: 'Intelligent Parsing',
    k_003003: 'Intelligent Subtitles',
    k_003004: 'AI Operations',
    k_003005: 'Highlight Moments',
    k_003006: 'Highlight Clips',
    k_003007: 'Summary',
    k_003008:
      'Accurately recognize human voices in videos to generate subtitles, automatically matching narration content with timestamps',
    k_003009:
      'Intelligently select key highlights in videos for easy viewing of interested content',
    k_003010:
      'Intelligently identify video content and clip into multiple highlight segments for content retention and redistribution',
    k_003011:
      'Intelligently extract key information and generate automatic summaries for clear visibility of core content',
    k_004001: 'Only {0} image formats are supported',
    k_004002: 'Image size cannot exceed {0}',
    k_005001: 'Failed to get replay info',
    k_005002: 'Please use this function after video transcoding completes',
    k_005003: 'Failed to query speech recognition info',
    k_005004: 'Failed to get replay details',
    k_005005: 'Intelligent analysis in progress, please try again later',
    k_005006: "Please switch to 'Intelligent Analysis' and generate summary first",
    k_007001: 'Playback Speed',
    k_008001: 'Image Editing',
    k_008002: 'Stretch to Full Screen',
    k_008003: 'Scale Proportionally to Fit',
    k_008004: 'Scale Proportionally to Show Full Image',
    k_008005: 'Crop',
    k_008006: 'Cancel Crop',
    k_008007: 'Re-upload',
    k_008008: 'Cancel',
    k_008009: 'Confirm',
    k_009001: 'Audio & Video List',
    k_009002: 'Log Out',
    k_009003: 'Logout failed',
    k_010001: 'Event Platform DEP',
    k_011001: 'Go to Settings',
    k_012001: 'Please enter a title',
    k_012002: 'Title cannot be empty',
    k_012003: 'Length must be 1-200 characters',
    k_012004: 'Edit',
    k_013001: 'No data available',
    k_013002: 'No matching content found',
    k_014001: 'Please enter keywords',
    k_015001: 'Upload failed',
    k_015002: 'Content exceeds {0} limit',
    k_015003: 'Content exceeds {0} limit, auto-canceled',
    k_016001: 'Cover',
    k_016002: 'Change',
    k_016003: 'Delete',
    k_016004: 'Upload failed',
    k_016005: 'Image uploading...',
    k_017001: 'Playback Speed',
    k_018001: 'Preview',
    k_019001: 'Creating:',
    k_019002: 'Full Content',
    k_019003: 'Document',
    k_020001: 'View Feature Intro',
    k_020002: 'Contact Support',
    k_020003:
      '「AI Creation」 is a paid feature. Contact your account manager or after-sales support, or call 400-888-9970 ext.2 for consultation.',
    k_020004:
      'Dear user, your account has expired. To ensure normal use, contact your account manager or after-sales support, or call 400-888-9970 ext.2 for consultation.',
    k_021001: 'Page disconnected, our team is fixing it...',
    k_021002: 'Reasons for inaccessible page:',
    k_021003: 'Server overload may cause service issues!',
    k_021004: 'The page does not exist or has been deleted by admin!',
    k_021005: 'Back',
    k_021006: 'Back to Home',
    k_022001: 'Account Binding',
    k_022002: 'User Login',
    k_022003: 'Account Login',
    k_022004: 'Phone Login',
    k_022005: 'Username/Email/Phone',
    k_022006: 'Please enter password',
    k_022007: 'Log In',
    k_022008: 'Please enter phone number',
    k_022009: 'This phone number is not registered, please register first',
    k_022010: 'Dynamic Password',
    k_022011: 'Get Verification Code',
    k_022012: 'Log In',
    k_022013: 'Please enter a valid phone number',
    k_022014: 'Please enter account',
    k_022015: '6-30 characters including uppercase, lowercase and numbers',
    k_022016: 'Please enter SMS verification code',
    k_022017: 'Please read and agree to the Privacy Policy and User Service Agreement',
    k_022018: 'Account does not exist',
    k_022019: 'Login verification failed',
    k_022020: 'Login failed!',
    k_022021: 'This phone number is already registered',
    k_022022: 'Registration failed',
    k_022023: 'Image verification code error',
    k_023001: 'Other login methods:',
    k_023002: 'Request failed',
    k_024001: 'Read and agree',
    k_024002: 'Submit implies agreement',
    k_024003: 'Privacy Policy',
    k_024004: 'and',
    k_024005: 'User Service Agreement',
    k_025001: 'Audio & Video',
    k_025002:
      'Files in audio & video are used for warm-up videos, on-demand, scheduled live and intercut files',
    k_025003: '1. Max single file size: 5G',
    k_025004: '2. Supported video formats: RMVB, MP4, AVI, WMV, MKV, FLV, MOV; Audio format: MP3',
    k_025005: '3. Uploaded videos do not support editing and download',
    k_025006: 'Upload',
    k_025007: 'Batch Delete',
    k_025008: 'Please enter audio & video name',
    k_025009: 'Audio & Video Name',
    k_025010: 'Upload Time',
    k_025011: 'Duration',
    k_025012: 'Size After Transcoding',
    k_025013: 'Progress',
    k_025014: 'Upload completed',
    k_025015: 'File uploading',
    k_025016: 'Action',
    k_025017: 'Preview',
    k_025018: 'AI Creation',
    k_025019: 'Edit',
    k_025020: 'Delete',
    k_025021: 'Request failed',
    k_025022: 'Transcoding',
    k_025023: 'Transcoding succeeded',
    k_025024: 'Transcoding failed',
    k_025025: 'Incorrect file format',
    k_025026: 'File cannot exceed 5G',
    k_025027: 'Do not close or refresh browser during upload',
    k_025028: 'File is uploading',
    k_025029: 'Local upload failed',
    k_025030: 'Video uploaded successfully',
    k_025031: 'Failed to create audio & video',
    k_025032: 'Please use this function after video transcoding completes',
    k_025033: 'Name cannot be empty',
    k_025034: 'Edit failed',
    k_025035: 'Edit succeeded',
    k_025036:
      'This file is linked. Deletion will make related files unplayable and unrecoverable. Confirm delete?',
    k_025037: 'Tip',
    k_025038: 'Confirm',
    k_025039: 'Cancel',
    k_025040: 'Deletion will affect warm-up video playback. Confirm delete?',
    k_025041: 'Delete failed',
    k_025042: 'Delete succeeded',
    k_026001: 'Select text and click left mouse button to add',
    k_026002: 'Got it',
    k_026003: 'Add',
    k_026004: 'Request failed',
    k_027001: 'Failed to get highlight clips',
    k_027002: 'Highlight clips: min 3, max 30',
    k_027003: 'Failed to submit task',
    k_028001: 'Not enough highlights? Try adding manually!',
    k_028002: '+ Add Now',
    k_028003: 'Recreate',
    k_028004: 'Recreating will overwrite previous content',
    k_028005: 'and manually added content',
    k_028006: 'Loading...',
    k_028007: 'Generation failed',
    k_028008: 'Add to Audio & Video',
    k_028009: 'Download',
    k_028010: 'Collapse',
    k_028011: 'Expand',
    k_028012: 'Recreating will overwrite previous content. Confirm recreate?',
    k_028013: 'Tip',
    k_028014: 'Confirm',
    k_028015: 'Cancel',
    k_028016: 'Request failed',
    k_028017: 'Added successfully',
    k_029001: 'Highlight Count',
    k_029002: 'Key Information',
    k_029003:
      'Optional. Enter key info to customize AI results, e.g.: include introduction to Vhall DEP, keywords EventHub, WebcastingHub, DataHub',
    k_029004: 'Word Count',
    k_029005: 'Optional, ≤30 words',
    k_029006: 'Reference Example',
    k_029007: 'Optional. Enter sample content for AI to follow the format',
    k_029008: 'Start Creating',
    k_030001: 'Download',
    k_030002: 'Duration:',
    k_030003: 'Content:',
    k_030004: 'Start Transcoding',
    k_030005: 'Tip:',
    k_030006: '1. Longer videos with subtitles take more time to transcode. Please wait',
    k_030007:
      '2. After transcoding, download video to your computer; 2 versions if subtitles are set (with/without subtitles)',
    k_030008: 'Transcode Again',
    k_030009: 'Download Now',
    k_030010: 'Video transcoding. Please wait. Closing popup won’t interrupt',
    k_030011: 'Transcode failed, please retry',
    k_030012: 'Failed to get video clip info',
    k_030013: 'Submit request failed',
    k_031001: 'Add',
    k_031002: 'Full Summary',
    k_031003: 'Max 50 items',
    k_031004: 'Cancel',
    k_031005: 'Confirm',
    k_031006: 'Add at least 1 item',
    k_031007: 'Request failed',
    k_032001: "Switch to 'Intelligent Analysis' first, then use '{0}'",
    k_032003: 'Creation time depends on video length. Please wait',
    k_032004: 'Creation failed, please retry',
    k_032005: 'Start Creating',
    k_032006: 'Intelligent Analysis',
    k_032007: 'Content Recognition',
    k_032008: 'Content Correction',
    k_032009: 'Correction Completed',
    k_032010: 'Highlight Moments',
    k_032011: 'Basic Settings',
    k_032012: 'Highlight Moments List',
    k_032013: 'Highlight Clips',
    k_032014: 'Highlight Clips List',
    k_032015: 'Summary',
    k_032016: 'Summary Content',
    k_032017: 'Intelligent Subtitles',
    k_032018: 'Mock child component slot output',
    k_033001: 'Intelligent Analysis',
    k_033002:
      'Analyze event video, get basic text via AI to support advanced features: Highlights, Clips, Summary, Subtitles',
    k_033003: 'Highlight Moments',
    k_033004: 'AI picks key video highlights for easier viewing',
    k_033005: 'Highlight Clips',
    k_033006: 'AI identifies and cuts into clips for content reuse',
    k_033007: 'Summary',
    k_033008: 'AI extracts and auto-summarizes key info',
    k_033009: 'Intelligent Subtitles',
    k_033010: 'Accurately recognize voice and auto-generate timed subtitles',
    k_034001: 'Select text, left-click to add',
    k_034002: 'Got it',
    k_034003: 'Add',
    k_034004: 'Marking task in progress, please retry later...',
    k_035001: 'Loading...',
    k_035002: 'Change Image',
    k_035003: '144x81, within 2M, jpg/png',
    k_035004: 'Collapse',
    k_035005: 'Expand',
    k_035006: '{0} words total',
    k_035008: 'Delete',
    k_035009: 'Upload failed',
    k_035010: 'Please enter text',
    k_036001: 'Not enough highlights? Add manually!',
    k_036002: '+ Add',
    k_036003: 'Recreate',
    k_036004: 'Recreating will overwrite previous content',
    k_036005: 'and manually added content',
    k_036006: 'No content',
    k_036007:
      "After saving, 'Highlight Moments' shows by default. Position, name and visibility can be adjusted in Custom Menu",
    k_036008: 'Preview Effect',
    k_036009: 'Save',
    k_036010: 'Failed to submit task',
    k_036011: 'Recreating will overwrite previous content. Confirm?',
    k_036012: 'Tip',
    k_036013: 'Confirm',
    k_036014: 'Cancel',
    k_036015: 'Deleted successfully',
    k_036016: 'Add highlights before saving',
    k_036017: 'Modified successfully',
    k_037001: 'Generated Count',
    k_037002: 'Key Information',
    k_037003:
      'Optional. Enter key info to customize AI results, e.g.: include Vhall DEP intro, keywords EventHub, WebcastingHub, DataHub',
    k_037004: 'Word Count',
    k_037005: 'Optional, ≤30 words',
    k_037006: 'Reference Example',
    k_037007: 'Optional. Enter sample for AI to follow format',
    k_037008: 'Start Creating',
    k_037009: 'Highlight count cannot be empty',
    k_038001: 'Undo',
    k_038002: 'Redo',
    k_038003: 'Search',
    k_038004: 'Left-click text to edit if recognition is inaccurate',
    k_038005:
      'Content generated by AI. Vhall does not guarantee accuracy or completeness, nor does it represent our views',
    k_038006: 'Correct content first for better Highlights, Clips, Summary and Subtitles',
    k_038007: 'Save',
    k_038008: 'Request failed',
    k_039001: 'AI Operations',
    k_039002: 'Full Content',
    k_039003: 'Content corrected. You can set:',
    k_039004: 'Download TXT',
    k_039005: 'Go to Settings',
    k_039006: 'Previous',
    k_039007: '{0}-Video Text-{1}.txt',
    k_039008: 'Failed to request info',
    k_040001: 'Output Language',
    k_040002: 'Please select',
    k_040004: 'Start Analysis',
    k_040005: 'Tip:',
    k_040006: '1. Chinese video → 简体中文; English → English; translation not supported',
    k_040007: '2. Re-analyzing will overwrite previous results and corrections',
    k_040008: 'Re-analyze will overwrite results and corrections. Confirm?',
    k_040009: 'Tip',
    k_040010: 'Confirm',
    k_040011: 'Cancel',
    k_040012: 'Parameter error',
    k_040013: 'Intelligent analysis not supported for this video',
    k_040014: 'Failed to submit analysis task',
    k_041001: 'No analysis',
    k_041002: 'Video < 3 minutes. Choose another video',
    k_041003: 'Analysis time depends on video length. Please wait',
    k_041004: 'Analysis failed, please retry',
    k_041005: 'Content Recognition',
    k_041006: 'Content Correction',
    k_041007: 'Correction Completed',
    k_042001: 'Content Correction',
    k_042002: 'Please enter content',
    k_042003: '{0} words total',
    k_042005: 'Cancel',
    k_042006: 'Confirm',
    k_043001: "Switch to 'Intelligent Analysis' first, then use 'Intelligent Subtitles'",
    k_043002: 'Intelligent Subtitles',
    k_043003: 'Enabled. Subtitles shown to viewers',
    k_043004: 'When enabled, viewers see subtitles',
    k_043005: 'Download TXT',
    k_043006: 'Edit Subtitles',
    k_043007: 'Regenerate',
    k_043008: 'Regenerating will overwrite previous subtitles',
    k_043009:
      "After saving, subtitles appear in playback; subtitled video available in 'Highlight Clips'",
    k_043010: 'Cancel',
    k_043011: 'Save',
    k_043012: "Generate subtitles first to edit and download subtitled video in 'Highlight Clips'",
    k_043013: 'Generate Subtitles',
    k_043014: 'Generation failed, please retry',
    k_043015: 'Start Creating',
    k_043016: 'Failed to get subtitle info',
    k_043017: 'Parameter error',
    k_043018: 'Failed to generate subtitles',
    k_043019: 'Operation failed',
    k_043020: '{0} Intelligent Subtitles',
    k_043021: 'Enable',
    k_043022: 'Disable',
    k_043023: '{0}-Subtitle-{1}.txt',
    k_043024: 'Regenerating will overwrite edited subtitles. Confirm?',
    k_043025: 'Tip',
    k_043026: 'Confirm',
    k_043027: 'Failed to save subtitles',
    k_043028: 'Saved successfully',
    k_044001: 'Subtitle Style',
    k_044002: 'Font Size',
    k_044003: 'Please select',
    k_044004: 'Font Style',
    k_044005: 'Font Color',
    k_044006: 'Opacity',
    k_044007: 'Stroke Color',
    k_044008: 'Cancel',
    k_044009: 'Confirm',
    k_044010: 'Failed to get subtitle style',
    k_044011: 'Parameter error',
    k_044012: 'Settings failed',
    k_044013: 'Settings saved',
    k_045001: 'Topic',
    k_045002: 'Recreate',
    k_045003: 'Recreating will overwrite previous and manual content',
    k_045004: 'Keywords',
    k_045005: 'Add',
    k_045006: 'Summary',
    k_045007: "After saving, 'Summary' shows by default. Adjust in Custom Menu",
    k_045008: 'Preview Effect',
    k_045009: 'Save',
    k_045010: 'Please enter keywords',
    k_045011: 'Add Keyword',
    k_045012: 'Cancel',
    k_045013: 'Confirm',
    k_045014: 'Topic Name',
    k_045015: 'Failed to submit task',
    k_045016: 'Recreating will overwrite content. Confirm?',
    k_045017: 'Tip',
    k_045018: 'Deleted successfully',
    k_045019: 'Keep at least 1 keyword',
    k_045020: 'Please enter topic',
    k_045021: 'Please enter summary',
    k_045022: 'Modified successfully',
    k_046001: 'Keyword Count',
    k_046002: 'Key Information',
    k_046003:
      'Optional. Customize AI results with key info, e.g.: Vhall DEP intro, keywords EventHub, WebcastingHub, DataHub',
    k_046004: 'Word Count',
    k_046005: 'Optional, ≤300 words',
    k_046006: 'Reference Example',
    k_046007: 'Optional. Enter sample for AI format reference',
    k_046008: 'Start Creating',
    k_046009: 'Highlight Moments count cannot be empty'
  },
  errorMap: {
    200: 'Success',
    201: 'Invalid request parameters',
    330: 'System busy, try again later.',
    400: 'Invalid request parameters',
    404: 'Resource does not exist',
    500: 'System busy, try again later.',
    501: 'System busy, try again later.',
    502: 'System busy, try again later.',
    600: 'Invalid request parameters',
    601: 'Record already exists.',
    602: 'User information not found.',
    603: 'Cannot delete due to associated resource apis.',
    700: 'Operation failure',
    701: 'Query failure',
    710: 'Operation failure',
    711: 'Operation failure',
    712: 'Query failure',
    720: 'Signature verification failed!',
    1005: 'Time expired',
    1008: 'Signature verification failed',
    1009: 'Invalid request parameters(app_id)',
    10000: 'Login verification failed',
    10017: 'Invalid request parameters',
    13220: 'Like data update failed',
    20002: 'Group name cannot be duplicated',
    20004: 'Grouping rule cannot be empty',
    20005: 'Group does not exist or has been deleted',
    20011: 'Group deletion failed',
    20013: 'Group creation failed',
    20015: 'Invalid request parameters',
    20016: 'Mobile number or email does not match',
    20040: 'User binding relationship mismatch',
    20045: 'User tag classification is incorrect',
    20046: 'Group name length exceeds the limit',
    20047: 'Group description length exceeds the limit',
    20052: 'Failed to obtain system group members',
    20070: 'Grouping rule is incorrect',
    20101: 'Member addition failed',
    20103: 'Group does not belong to the user',
    20500: 'Failed to process user data',
    20501: 'Third-party user does not exist!',
    20502: 'Mobile number or email has been bound to another account!',
    20503: 'Mobile number and email do not belong to the same account!',
    20506: 'Account already exists',
    21000: 'Category does not exist',
    21001: 'Tag name already exists',
    21002: 'Category name cannot be empty',
    21003: 'Category name already exists',
    21004: 'Tag name cannot be empty',
    21005: 'Addition failed',
    21006: 'Update failed',
    21007: 'B-side user does not have this tag',
    30001: 'Data format error',
    30002: 'Batch addition to group failed',
    30003: 'Merchant transfer scenario mismatch',
    30006: 'User does not exist',
    30012: 'Current balance is less than the deducted balance',
    30014: 'User ID already exists',
    30015: 'User ID and SSO ID cannot both be empty',
    30016: 'Invalid request parameters',
    30017: 'C-side user does not exist',
    30018: 'B-side user does not exist',
    30019: 'Invalid request parameters',
    30020: 'Invalid request parameters',
    30021: 'User cannot be upgraded to B-side user',
    30022: 'User cannot be downgraded to C-side user',
    30023: 'Invalid request parameters',
    30024: 'Invalid request parameters',
    30025: 'Private domain user pool function is not enabled',
    30026: 'User configuration type does not exist',
    50001: 'WeChat union ID is not bound to a mobile number',
    50005: 'Mobile number and WeChat union ID are both empty',
    50012: 'Mobile number cannot be empty',
    50013: 'Mobile number is incorrect',
    50014: 'Mobile number is incorrect',
    50050: 'Invalid request parameters',
    50100: 'Mobile number is incorrect',
    50101: 'Email address is incorrect',
    50210: 'Invalid request parameters',
    50211: 'Invalid request parameters',
    50212: 'Account cannot be empty',
    50213: 'Password cannot be empty',
    50214: 'SSO ID cannot be empty',
    50400: 'Data update failed',
    60000: 'Invalid request parameters',
    60001: 'Fault code configuration does not exist',
    60002: 'Fault code configuration already exists',
    60003: 'Fault code has been deactivated',
    60004: 'Fault code already released',
    100001: 'Webinar id is incorrect',
    200021: 'C-side user id is incorrect',
    200023: 'First entry time is incorrect',
    200025: 'Invalid request parameters',
    200026: 'user flag is incorrect',
    200035: 'Channel source is incorrect',
    200040: 'Visitor ID does not exist',
    200041: 'Mobile number is incorrect',
    200042: 'Mobile number is incorrect',
    200043: 'Third-party user ID is incorrect',
    200044: 'Role ID is incorrect',
    200045: 'Invalid request parameters',
    410000: 'Activity does not match the user',
    410001: 'Session does not match the activity',
    410002: 'Failed to get logged-in user information',
    410003: 'The number of queried activities exceeds the limit. ',
    410004: 'Failed to get a valid logged-in user ID',
    410005: 'Site does not match the user',
    410006: 'File upload failed',
    410007: 'File download failed',
    500000: 'Failed',
    510000: 'Invalid request parameters',
    510001: 'System busy, try again later.',
    510002: 'Result data error',
    510003: 'Undefined return field type',
    510004: 'Undefined whether return field is mandatory.',
    510005: 'Return result must be an object.',
    510006: 'Validation rules cannot be empty',
    510007: 'No permission.',
    510008: 'Not logged in.',
    510009: 'User does not exist',
    510010: 'Operation failed, please try again later',
    510011: 'Platform parameter error',
    510012: 'App not found.',
    510013: 'Cannot contain Chinese characters and special characters!',
    510014: 'Start time cannot be earlier than end time!',
    510015:
      'System is under maintenance from 00:00 to 07:00. We apologize for any inconvenience caused.',
    510016: 'Number of data entries exceeds the limit',
    510017: 'Missing public parameter: B user ID',
    510018: 'Verification code error',
    510019: 'Please login first',
    510020:
      'Activation failed. Mandatory login before appointment has been enabled for this activity. Please disable it and try again.',
    510021: 'Configuration item format error',
    510025: 'This data already exists, please reset it',
    510037: 'Unreachable',
    510040: 'Data does not exist',
    510041: 'Data does not belong to the current user',
    511001: 'Graphic verification code error',
    511002: 'Dynamic password error',
    511003: 'Invalid account/password! 4 errors lock account',
    511004: 'Your account has been suspended due to non-compliant operations!',
    511005: 'User token missing.',
    511006: 'User token authentication failed.',
    511007: 'User token has expired.',
    511008: 'Data does not exist',
    511009: 'Verification code error',
    511010: 'User registration failed',
    511011: 'User already exists',
    511012: 'Verification of previous operation result failed.',
    511013: 'Old password cannot be empty',
    511014: 'Old password error.',
    511015: 'Password input inconsistent',
    511016: 'Mobile phone number format error.',
    511017: 'Email format error.',
    511018: 'Verification code error',
    511019: 'Failed to send verification code',
    511020: 'Sub-account has no operation permission.',
    511021: 'Not a sub-account.',
    511022: 'This mobile number is bound to another account',
    511023: 'This email is bound to another account',
    511024: 'Do not repeat requests within a short period.',
    511025: 'Avatar upload exception.',
    511026:
      'Current third-party user has been created  password data is inconsistent  please use the update interface to modify data.',
    511027: 'Current user has been deleted on the saas platform',
    511028: 'Third-party user object does not exist.',
    511029: 'Exceeds sub-account quantity limit.',
    511030: 'Invalid role id, not created by the main account.',
    511031: 'Sub-account has no permission to create accounts.',
    511032: 'Password already exists, direct setting not allowed.',
    511033: 'No access permission.',
    511034: 'Invalid platform.',
    511035: 'Can only modify data under your own account.',
    511036: 'User already exists.',
    511037: 'Uploaded image is too large.',
    511038: 'Unsupported upload file type.',
    511039: 'Current account is already bound, please unbind first.',
    511040: 'Batch create sub-accounts, quantity cannot be empty.',
    511041: 'Third-party account information missing',
    511042: 'Already bound to another account.',
    511043: 'Interface access count reaches maximum limit.',
    511044: 'Data signature error',
    511045: 'Current logged-in user does not exist.',
    511046: 'Invalid request parameters(sign_type)',
    511047: 'Permission key does not exist.',
    511048: 'Sub-account relationship error',
    511049: 'Failed to modify menu sort order.',
    511050: 'Email does not meet requirements, must be a corporate email!',
    511051: 'Account suspension reason cannot be empty.',
    511052: 'Current user does not have this value-added api',
    511053: 'Current account is not bound, no need to unbind.',
    511054: 'Account affiliation error.',
    511055: 'Mobile phone number not registered.',
    511056: 'You are not an employee.',
    511057: 'Please enter the correct verification code.',
    511058: 'Invalid token.',
    511059: 'Adding this configuration item is not allowed for non-members or expired members.',
    511060: 'App not found.',
    511061: 'Sub-account quantity must be between 1 and 200!.',
    511062: 'Cannot enable sub-account permissions!',
    511063: 'Sub-account is live streaming, deletion not allowed.',
    511064: 'Sub-account has earnings, deletion not allowed.',
    511065: 'Request has expired, please initiate again!.',
    511066: 'Data signature error!',
    511067: 'Application does not exist',
    511068: 'No sub-account permission',
    511069: 'Permission key  exists.',
    511070: 'Permission not activated for OpenAPI',
    511071: 'Permission not activated for JSSDK',
    511072: 'Permission not activated for APPSDK',
    511073: 'Permission not activated for MiniprogramSDK',
    511074: 'Invalid Member',
    511075: 'Please fill in your own mobile phone number',
    511076: 'User in migration is temporarily inaccessible',
    511077: 'The visitor already exists and no need to create',
    511078: 'E-mail cannot be empty',
    511079: 'Current account is prohibited from logging in.',
    511080: 'Publishing failed',
    511081: 'Please disable the global error code first',
    511082: 'Sub-account creation is not allowed for time-based billing',
    511083:
      'The legacy system does not support time-based packages. If you need to roll back, please change the package first and then operate',
    511084: 'Your application has expired.',
    511085: 'Your application is not in effect or has been closed',
    511086: 'Application has been deactivated',
    511087: 'User is not registered',
    511088: 'Invalid request parameters,signed_at',
    511089: 'Invalid request parameters,signed_at',
    511090: 'This account is already registered,please go to log in',
    511091: "This user's mobile phone number is not empty!",
    511092: 'Sub-account cannot be rolled back to a third-party account!',
    511093: 'Old platform users are not allowed to enable this permission.',
    511094: 'Account locked for 10 minutes',
    511095: 'Permission for private domain user pool is not enabled',
    511096: 'Mobile phone number or email already exists!',
    511097: 'Mobile phone number and email do not belong to the same user!',
    511098:
      'When the playback valid period type is full-day, start_date and end_date cannot be empty',
    511099:
      'When the playback valid period type is partial period, start_time and end_time cannot be empty',
    511100:
      'Password must contain uppercase and lowercase letters and numbers, with a length of 6-30 characters',
    511101: 'This sub-account is in arrears, please recharge and try again!',
    511102:
      'The permissions of setting logo and using parent account logo cannot be enabled at the same time',
    511103: 'Report feedback cannot be closed!',
    511501: 'Data does not exist!',
    511502: 'Data already exists.',
    511503: 'Database error.',
    511504: 'Permission category id cannot be empty.',
    511505: 'Account muted.',
    511506: 'Sso registration failed.',
    511507: 'Registration failed.',
    511508: 'Permission in use, cannot delete sub-account permission.',
    511509: 'Exceeded app maximum limit.',
    511510: 'No developer permissions.',
    511511: 'Permission id exception.',
    511512: 'User does not exist',
    511513: 'Duplicate with existing employee email',
    511514: 'duplicate with existing employee name',
    511515: 'Associated users exist',
    511516: 'Can only modify own data.',
    511517: 'Mobile phone number is not exists!',
    511518: 'Missing  employee id',
    511521: 'Current api_url is incorrect.',
    511522: 'Current user does not have this value-added api',
    511523: 'Frequency limit configuration already exists.',
    511524: 'Id does not exist.',
    511525: 'User api permission not activated.',
    511528: 'This user has already configured this interface!.',
    511529: 'Failed to modify menu sort order.',
    511530: 'Invalid request parameters',
    511531: 'No modification permission under the account',
    511532: 'Modification is not allowed in the in-progress state!',
    511533: 'Cancellation is not allowed if the status is not "in progress"!',
    511534: 'Cancellation is not allowed within 24 hours of migration',
    511535: 'Migration is not required for this user!',
    511536: 'Need check id.',
    512000: 'Deletion failed.',
    512001: 'Deletion failed.',
    512002: 'Activity does not exist or has been deleted.',
    512003: 'This activity does not belong to the user',
    512004: 'Activity creation failed.',
    512005: 'Activity extended information creation failed.',
    512006: 'Activity modification failed.',
    512007: 'Activity modification exception.',
    512008: 'Warm-up video deletion exception.',
    512009: 'Warm-up video cover replacement failed.',
    512010: 'Warm-up video does not exist.',
    512011: 'Warm-up video addition failed.',
    512012: 'Audience group creation failed.',
    512013: 'Audience group modification failed.',
    512014: 'Audience group deletion failed.',
    512015: 'Group does not exist.',
    512016: 'Third-party verification setting failed.',
    512017: 'Whitelist audience does not exist.',
    512018: 'Whitelist audience modification failed.',
    512019: 'Whitelist audience deletion failed.',
    512020: 'Whitelist audience creation failed.',
    512021: 'Invitation code creation quantity exceeds limit.',
    512022: 'Batch creation of whitelist audience exceeds limit.',
    512023: 'Necessary parameters for modifying viewing restrictions are missing.',
    512024: 'This whitelist does not belong to this user.',
    512025: 'Viewing restriction saving failed.',
    512026: 'This activity type does not support modifying guests.',
    512027: 'Role permission modification failed.',
    512028: 'Topic creation failed.',
    512029: 'Topic does not exist.',
    512030: 'Topic deletion failed.',
    512031: 'Topic modification failed.',
    512032: 'On-demand creation failed.',
    512033: 'Playback does not exist',
    512034: 'On-demand session information does not exist.',
    512035: 'On-demand does not support role settings.',
    512036: 'Part of this user information already exists in this group.',
    512037: 'Whitelist user does not exist.',
    512038: 'Cannot operate on whitelist audiences under other accounts.',
    512039: 'User group does not exist.',
    512040: 'Guest password and assistant password cannot be the same.',
    512041: 'Topic does not belong to this user.',
    512042: 'Graphic verification code error.',
    512043: 'This audio/video does not belong to this user.',
    512044: 'Audio/video creation failed.',
    512045: 'Audio/video modification failed.',
    512046: 'Audio/video deletion failed.',
    512047: 'Activity extended information modification failed.',
    512048: 'Playback does not belong to this user.',
    512049: 'This group already exists.',
    512050: 'Insufficient user concurrency to create this activity.',
    512051: 'Activity maximum concurrency exceeds limit.',
    512052: 'Live streaming in progress, please try after ending it!',
    512053: 'Template is incorrect',
    512054: 'Sub-account does not belong to current user.',
    512055: 'Live event in progress, cannot delete',
    512056: 'Package does not support this function',
    512057: 'This image resource is invalid',
    512058: 'No permission to create on-demand from playback',
    512059: 'Start time cannot be earlier than current time',
    512060: 'Gray environment id already exists.',
    512061: 'Activity migration failed',
    512062: 'Cache refresh failed.',
    512063: 'This topic has been taken offline!',
    512064: 'Interstitial broadcast does not exist',
    512065: 'Interstitial broadcast does not belong to this user',
    512066: 'nterstitial broadcast does not belong to this event',
    512067: 'Interstitial broadcast creation failed',
    512068: 'Event creation failed, exceeding the maximum number of co-hosts for the account',
    512069: 'The default language has been created for this event!',
    512070: 'Cloud director cannot be low-latency live streaming',
    512071: 'This event is not a cloud director event!',
    512072: 'Cloud director events can only be video live streaming!',
    512073: 'Tag name already exists',
    512074: 'A maximum of 1000 tags can be created under an account',
    512075: 'A maximum of 50 tags can be associated',
    512076: 'The currently selected tags do not exist',
    512077: 'Tag is already pinned, cannot pin repeatedly',
    512078: 'Tag deletion failed',
    512079: 'The list contains referenced tags, please select again',
    512080: 'Tag name cannot be empty',
    512081: 'Event ID and topic ID cannot be empty at the same time',
    512082: 'A maximum of 10 multi-K value verifications can be created!',
    512083: 'Audiovisual does not exist or has been deleted',
    512084: 'Please check if k_id is correct',
    512085: 'Please check if the event ID corresponds to k_id',
    512086: 'Event has not started broadcasting',
    512087: 'A maximum of 10 groups can be exported in batches',
    512088: 'This video resource does not belong to playback',
    512089: 'This video resource does not support transcoding to this resolution',
    512090: 'No permission for this resolution',
    512091: 'This video has not been transcoded successfully yet',
    512092: 'Video and resolution configuration cannot be modified during live streaming',
    512095:
      'The duration of the selected audio and video for scheduled live streaming shall not be less than 3 minutes',
    512098: 'The migration activity of the legacy system does not support multiple whitelists',
    512101: 'Resource is being encrypted, operation not allowed',
    512102: 'Resource is already encrypted, operation not allowed',
    512103: 'No permission for scheduled live streaming currently',
    512104: 'Scheduled live streaming does not support restoring to preview',
    512105: 'Time cannot be modified when the scheduled live streaming is in progress',
    512106: 'Scheduled live streaming does not support host participation',
    512107: 'Video source cannot be changed during scheduled live streaming',
    512108:
      'The current event is a scheduled live stream, and modifying the event status is not supported',
    512109: 'Scheduled live streaming does not support guest participation',
    512110: 'User has no permission for grouped events',
    512111: 'Grouped events cannot have no viewing restrictions',
    512112:
      'Unified restrictions cannot be set for this topic because its subordinate events belong to other topics at the same time',
    512113: 'This playback is a rehearsal playback, operation not allowed',
    512114: 'Event is in rehearsal, current operation not supported',
    512115: 'In rehearsal, cannot be adjusted',
    512116: 'This playback does not support re-creation',
    512117: 'Configuration items cannot be modified during rehearsal or live streaming',
    512118: 'Switch operations are not allowed during rehearsal or live streaming',
    512119: 'A maximum of 200 events can be set under a single topic',
    512120: 'Only video live streaming and scheduled live streaming support portrait mode creation',
    512121: 'Portrait mode does not support cloud director function',
    512122: 'No permission for portrait mode currently',
    512123: 'Portrait mode can only be initiated via app or SDK',
    512124: 'Portrait mode does not support cloud director',
    512125: 'Portrait mode does not support video polling',
    512126: 'Portrait mode does not support live room designer',
    512127: 'Screen orientation cannot be modified for live streams that have been launched',
    512128: 'Real-time subtitles are a paid feature.',
    512129:
      'Real-time subtitles are not supported for low-latency live streaming, grouped live streaming and on-demand playback',
    512130: 'This operation is not supported for non-scheduled live streaming',
    512131: 'This resolution is not supported for this live stream',
    512132:
      'The video is currently being transcoded to another resolution. Please submit a new transcoding task after the current one is completed',
    512200: 'Chinese and English events in the same group cannot be the same',
    512201: 'An event cannot be added to multiple bilingual groups at the same time',
    512202: 'A maximum of 50 bilingual pairs can be set under a single topic',
    512203: 'This event is part of a bilingual topic and cannot be added again',
    512204: 'Bilingual topic events cannot belong to other topics at the same time',
    512205: 'Activity group does not exist or has been deleted.',
    512206: 'Only one Chinese event and one English event can be added to a single bilingual group',
    512300: 'At least one language shall be retained',
    512501: 'Activity creator does not exist.',
    512502: 'Unsupported activity type (flash).',
    512503: 'Unsupported activity type (old h5).',
    512504: 'Unsupported activity type (on-demand).',
    512505: 'Room not found.',
    512506: 'Token has expired.',
    512507: 'Token verification failed',
    512508: 'Non-interactive mode does not support guest participation.',
    512509: 'Role permissions not enabled.',
    512510: 'The current password is incorrect',
    512511: 'A host has already entered the live room',
    512512: '%s has exceeded 20 concurrent online users; You cannot enter the live room;',
    512513:
      'Detected that you have logged in to the organizer account, please log out first or access with another browser.',
    512514: 'You are prohibited from accessing the room!',
    512515: 'Participation data not found.',
    512516: 'This account has already entered the live stream.',
    512517: 'No interactive live stream permission.',
    512518: 'Interactive mode does not support relaying.',
    512519: 'Cannot relay repeatedly.',
    512520: 'Relay source cannot be the same as the relay target.',
    512521: 'Live broadcast has not started.',
    512522: 'Hosts, guests or assistants cannot enter the viewer side during live streaming',
    512523: 'Payment required.',
    512524: 'Relayed activity has not started live stream.',
    512525: 'Registration form needs to be filled out.',
    512526: 'Detection type is inconsistent with activity viewing restriction type.',
    512527: 'Password error.',
    512528: 'Please enter password.',
    512529: 'Invitation code error.',
    512530: 'Invitation code already used.',
    512531: 'Please enter invitation code.',
    512532: 'Please enter whitelist mobile number | email | employee id | others.',
    512534: 'Jump link.',
    512535: 'The organizer has set a verification mechanism for this activity.',
    512536: 'Playback does not exist.',
    512537: 'Popularity cannot be less than the number of online users.',
    512538: 'The organizer has set a verification mechanism for this activity,verification failed.',
    512539: 'Sdk verification only supports key value verification.',
    512540: 'Activity has ended.',
    512541: 'The activity venue is too popular, exceeds the maximum number of participants.',
    512542: 'Visitor data information is incomplete.',
    512543: 'This video is temporarily offline.',
    512544: 'This video has been taken offline',
    512545: 'This video transcoding failed.',
    512546: 'This video is being transcoded.',
    512547:
      'The embedded page only supports three verification methods: default password  third-party k value!',
    512548: 'Recording in progress, cannot initiate live stream.',
    512549: 'Non-live activity.',
    512550: 'Live broadcast in progress, cannot initiate recording.',
    512551: 'Only audio/video supported.',
    512552: 'Resolution error,currently only supports a/360p/480p/720p/same.',
    512553: 'Callback address format error.',
    512554: 'Uploaded on-demand not allowed to operate.',
    512555: 'Current resolution has been converted',
    512556: 'Current resolution has been converted',
    512557: 'Current resolution system transcoding failed!',
    512558: 'Current resolution download task has been requested',
    512559:
      'The playback of the currently downloaded resolution has not been generated, please generate it first before downloading!',
    512560: 'This video is under review.',
    512561: 'Stream information does not exist.',
    512562: 'Infinite edition traffic-based has reached the limit.',
    512563: 'Concurrent has reached the limit.',
    512564: 'Infinite edition concurrency-based has reached the limit.',
    512565: 'Activity owner is not a member, cannot enter temporarily.',
    512566: 'The chapter you modified is being saved.',
    512567: 'Unsupported activity type (must be on-demand).',
    512568: 'Callback address not passed and not configured.',
    512569: 'No permission to operate host email.',
    512570: 'Sms verification code error.',
    512571: 'Traffic-based users with arrears exceeding 100G cannot enter temporarily',
    512572: 'The current password has expired',
    512573: 'The email has been used by others',
    512574: 'Expiration time cannot be earlier than the current time',
    512575: 'Expiration time cannot exceed 30 days',
    512576: 'Current version is too low, please update to the latest version to launch the event!',
    512577:
      'Current version does not support low-latency live streaming, please upgrade to the latest version to use it',
    512578: 'The event has expired and cannot start live streaming',
    512579: 'The event has been banned by the administrator',
    512580:
      'The current live stream has been forcibly ended by the administrator and cannot be restarted!',
    512581:
      'Current version only supports 1v5 co-hosting, please upgrade to the latest version for more co-hosts',
    512582:
      'Current version does not support playing encrypted videos, please upgrade to the latest version to use it',
    512583:
      'Grouped live streaming is not supported temporarily, please launch it on the web version',
    512584: 'No permission for grouped live streaming',
    512585:
      'Grouped live streaming viewing is not supported temporarily, please use the web version',
    512586: 'Virtual audience size setting is not supported for grouped live streaming temporarily',
    512587: 'Time-based users with arrears exceeding 100 minutes cannot enter temporarily',
    512588:
      'Single video embedding is not supported for grouped live streaming viewing temporarily',
    512591:
      'Viewing language is a paid feature. Please contact your account manager or call customer service to activate it',
    512592:
      'Grouped live streaming does not support multiple languages temporarily, please select Simplified Chinese',
    512593:
      'Current version does not support video polling function, please upgrade to the latest version to use it',
    512594: 'APP version is too low, please upgrade to use',
    512595: 'Only video live streaming is supported',
    512600: 'Exception when starting or ending activity.',
    512601: 'Exception when starting or closing relay stream.',
    512602: 'Symbol parameter format error.',
    512603: 'Identity information format error.',
    512604: 'Not the playback of the activity.',
    512605: 'Whitelist invalid, please clear cache and re-fill.',
    512606: 'Registration form invalid, please clear cache and re-fill.',
    512607: 'Please execute start marking first.',
    512608: 'Failed to request streaming media interface.',
    512609: 'Host participation record already exists.',
    512610: 'The user has already used the whitelist; do not reuse it',
    512611: 'The user has already used the invitation code; do not reuse it',
    512612: 'Webinar id is exists',
    512613: 'Records does not exist',
    512614: 'The time span shall not exceed 72 hours',
    512615: 'Recording in progress, cannot initiate rehearsal.',
    512616: 'Live broadcast in progress, cannot initiate rehearsal.',
    512617: 'Recording cannot be initiated during rehearsal',
    512618: 'Live streaming cannot be initiated during rehearsal',
    512619:
      'The live stream is currently in rehearsal; please upgrade to the latest version to enter the live room',
    512620: 'The default record cannot be deleted',
    512621: 'Cannot operate on a kid that does not belong to you',
    512622: 'The current initiator is not supported; please use the web version to initiate',
    512623:
      'The current version does not support merged mode layout; please upgrade to the latest version to use this feature',
    512624: 'The current initiator is not supported; please use the web version to initiate',
    512625: 'Verification method only supports free, password and whrite-list',
    512626: 'The current activity does not match the account information; viewing is not allowed',
    512630:
      'Live streaming real-time AI minutes function is not supported for group live streaming and on-demand streaming',
    512700: 'A maximum of 30 push streams can be created under an event',
    512701: 'The push stream address already exists',
    512702: 'The push stream record does not exist',
    512704:
      'A third-party push stream is in progress; please go to the web page to enter the live stream',
    512705:
      'Push streaming only supports four live stream modes: audio, video, interaction and grouping',
    512800: 'Registration form cannot be enabled simultaneously with whitelist.',
    512801: 'Exceeds maximum number of questions allowed in registration form.',
    512802: 'Question does not exist.',
    512803: 'Privacy agreement does not exist.',
    512804: 'Exceeds maximum number of options allowed per question.',
    512805: 'No operation permission.',
    512806: 'Question option does not exist.',
    512807: 'Options cannot be less than 1.',
    512808: 'Current role prohibited from registering.',
    512809: 'Sms verification code error.',
    512810: 'Registration data missing.',
    512811: 'Question options must be a json string.',
    512812: 'Question prohibited from deletion.',
    512813: 'Privacy agreement already added.',
    512814: 'This mobile number has already registered.',
    512815: 'User has already registered  no need to register again.',
    512816: 'Mobile phone question information missing.',
    512817: 'Not registered.',
    512818: 'Registration data format error',
    512819: 'Pre-registration excel content error.',
    512820: 'The topic registration form is not enabled',
    512821: 'The topic viewing restriction does not use the registration form',
    512822: 'The quick registration is limited to a maximum of 200 entries',
    512823: 'Data import is currently in progress; please try again later',
    512824: 'Registration import data does not exist',
    512825: 'Duplicate registration with the same mobile phone number is not allowed',
    512826: 'File processing error.',
    512827:
      'When selecting specific events for registration in the topic registration form, webinar_ids cannot be empty',
    512828:
      'Detected that the event has been deleted or not associated with the topic; please try again',
    512829:
      'The login mobile phone number is inconsistent with the registration mobile phone number',
    512830: 'Registered User List',
    512831:
      'The registration mobile phone number and the login mobile phone number do not belong to the same user',
    512855: 'The email verification code is incorrect',
    512856:
      'At least one of the mobile phone number and email address must be retained, and it is a required field',
    512900: 'Clip time list parameter error.',
    512901: 'Transcoding in progress, please wait.',
    512902: 'Please retry.',
    512903: 'Activity log information creation failed.',
    512904: 'Activity log information modification failed.',
    512905: 'On-demand cannot cancel default selection.',
    512906: 'Please start recording first before requesting this api.',
    512907: 'Creation failed.',
    512908: 'Incorrect time format.',
    512909: 'The interval time range cannot be less than 10 seconds!',
    512910: 'A maximum of 20 video files can be selected',
    512911: 'Playback is being generated; no operations can be performed',
    512912: "The video's viewing valid period has expired",
    512913: 'The playback list supports a maximum of 100 entries',
    512920: 'There is no presentation document in the current playback content',
    512921: 'The field name or field identifier already exists',
    512922: 'The custom field does not exist',
    512923: 'The length of the custom field value shall not exceed 100 characters',
    512924: 'The live custom field is missing',
    512925: 'No permission for custom fields',
    512926: 'A maximum of 5 custom fields are supported for live broadcasts',
    512931: 'No permission for third-party registration forms',
    512941: 'The custom domain name already exists',
    512942: 'Failed to generate the custom domain name',
    512997:
      'Live streaming is not supported for paid events temporarily; please adjust and start streaming again',
    512998: 'The price only allows input of 0',
    512999: 'This function is not supported temporarily',
    513000: 'Participating user does not exist.',
    513001: 'Prohibited from calling during live stream.',
    513002: 'Call forbidden when live stream has not started',
    513003: 'Operation forbidden',
    513004: 'User failed to join the room.',
    513005: 'Deletion failed.',
    513006: 'Update failed.',
    513007: 'Room does not exist.',
    513008: 'Host information missing.',
    513009: 'Room is not a live stream activity',
    513010: 'Room already exists.',
    513011: 'Current participating user has not joined the live room.',
    513012: 'Only host has this permission.',
    513013: 'Only creator has this permission.',
    513014: 'Only guests are allowed to operate.',
    513015: 'Regular audience has no this permission.',
    513016: 'Q&A must be enabled.',
    513017: 'Audio activity cannot use interactive mic connection.',
    513018: 'Q&A has been muted',
    513019: 'Same ask status mismatch.',
    513020: 'User does not have this permission',
    513021: 'Room does not exist',
    513022: 'The live stream you are participating in is not the current one.',
    513023: 'Raise hand function not available yet',
    513024: 'Role mismatch',
    513025: 'The number of seats for on-mic is full, your account supports %d people on-mic',
    513026: 'Current user has not applied for on-mic',
    513027: 'Current user has not participated.',
    513028: 'Current user has already been invited',
    513029: 'Repeatedly going on mic.',
    513030: 'Not invited',
    513031: 'Host does not need to go on mic.',
    513032: 'Forbidden to go off-mic',
    513033: 'User is not on-mic',
    513034: 'Current user cannot go on mic.',
    513035: 'Only the host can take themselves off-mic',
    513036: 'User is muted, cannot apply for on-mic',
    513037: 'Current participant is not in presentation mode, operation not allowed',
    513038: 'Discussion not started, failed to send announcement',
    513039: 'Interface access is too frequent, please try again later',
    513040: 'Exceeds profanity word quantity limit.',
    513041: 'Operation failed.',
    513042: 'Keyword has been deleted or does not exist',
    513043: 'Profanity word already exists.',
    513044: 'Operation failed.',
    513046: 'Moving marquee watermark information does not exist.',
    513047: 'Current activity does not belong to current user',
    513048: 'Operation failed.',
    513049: 'Image cannot be empty when enabling watermark.',
    513050: 'Menu type mismatches status.',
    513051: 'Invitation list function component can only be added once.',
    513052: 'Maximum 10 image-text components can be added under one menu.',
    513053: 'Maximum 50 live broadcasts can be added on one page.',
    513054: 'Maximum 50 topics can be added on one page.',
    513055: 'Illegal component data.',
    513056: 'The ranking component can only be added once',
    513057: 'Maximum 6 custom menus allowed.',
    513058: 'Invalid address!',
    513059: 'The current custom menu has been deleted',
    513060: 'Menu does not exist',
    513070: 'Creation failed.',
    513071: 'Update failed',
    513072: 'Deletion failed',
    513073: 'Number of ad recommendations reaches maximum limit',
    513074: 'Number of ad recommendations reaches maximum limit',
    513075: 'Addition failed.',
    513076: 'Shelving failed.',
    513077: 'Unshelving failed.',
    513078: 'Copying failed.',
    513079: 'Copied product does not exist.',
    513080: 'Maximum number of shelved products: 100.',
    513081: 'Addition failed.',
    513082: 'Update failed.',
    513083: 'Image saving failed.',
    513084: 'Deletion failed',
    513085: 'Deletion failed',
    513086: 'Setting failed',
    513087: 'Creation failed.',
    513088: 'Update failed.',
    513089: 'Status update failed.',
    513090: 'Creation failed.',
    513091: 'Update failed.',
    513092: 'Operation failed.',
    513093: 'Saving failed.',
    513094: 'Not enabled.',
    513095: 'Invitation creation failed.',
    513096: 'Invitation creation failed.',
    513097: 'File address error.',
    513098: 'Creation failed.',
    513099: 'Red packet amount must be a positive number.',
    513100: 'Activity does not exist.',
    513101: 'The document already exists in the resource library',
    513102: 'This document already exists in the current activity.',
    513103: 'Failed to sync to resource library',
    513104: 'Failed to sync to activity',
    513105: 'Document does not exist',
    513106: 'Document deletion exception.',
    513107: 'Document does not exist',
    513108: 'Document parameter incorrect.',
    513109: 'Document has been deleted or does not exist.',
    513110: 'Current document attribution incorrect.',
    513111: 'Document does not exist',
    513112: 'Current user has no permission.',
    513121: 'Question does not exist.',
    513122: 'Do not process repeatedly.',
    513123: 'Answer does not exist.',
    513124: 'Room start time missing.',
    513125: 'Question does not belong to this room.',
    513126: 'Cannot ask questions within 15 seconds',
    513127: 'The message has been deleted',
    513128: 'Do not repeatedly ask the same question frequently',
    513129: 'Cannot operate as the "visible to all" function is not enabled',
    513200: 'Failed to initiate check-in!',
    513201: 'Check-in duration cannot be empty!',
    513202: 'Auto check-in option cannot be empty!',
    513203: 'Check-in time interval cannot be empty!',
    513204: 'Current activity is already in check-in!',
    513205: 'Check-in has ended.',
    513206: 'Check-in not exists.',
    513207: 'Push time must be later than the current time and the live streaming start time!',
    513220: 'Like data update failed.',
    513230: 'Share type error.',
    513231: 'Sharing failed.',
    513232: 'Sharing failed.',
    513240: 'Exceeds custom gift quantity limit.',
    513241: 'Current user has no permission to operate this room.',
    513242: 'Gift information does not exist or has been deleted!',
    513243: 'Fixed gifts cannot be deleted.',
    513244: 'Can only delete gifts created by yourself.',
    513245: 'Creation failed.',
    513246: 'Editing failed.',
    513247: 'Gift information does not exist.',
    513248: 'Fixed gifts cannot be edited.',
    513249: 'You have no permission to edit this gift information.',
    513250: 'Exceeds gift quantity limit for activity.',
    513251: 'gift_ids format error.',
    513252: 'At least one gift must remain in the display state',
    513270: 'File information parameter error.',
    513271: 'Work order creation failed.',
    513272: 'Work order creation failed.',
    513273: 'Work order information does not exist.',
    513274: 'Work order reply failed.',
    513275: 'Status update failed.',
    513276: 'Work order issue resolved, reply prohibited.',
    513277: 'Please create work order in console.',
    513278: 'No permission.',
    513280: 'Failed to obtain product details.',
    513281: 'Discount price cannot be greater than or equal to original price.',
    513282: 'Illegal image',
    513283: 'Product does not exist',
    513284: 'Cover must be selected from the uploaded images',
    513285: 'Product has been shelved, please unshelve first for editing.',
    513288: 'Please use this function after the live stream starts',
    513290: 'Promotion application does not exist',
    513301: 'File format error.',
    513302: 'Please upload using template file',
    513311: 'Timer already exists',
    513312: 'Timer does not exist',
    513321: 'Creating groups exceeds the maximum limit',
    513322: 'Failed to apply for resources for the group',
    513323: 'Group does not exist',
    513324: 'Incorrect group selection method',
    513325: 'The current user has not entered the room',
    513326: 'Operating user is not in the same room',
    513327: 'The user is not a member of the current group',
    513328: 'The user is offline',
    513329: 'Only regular users can be set as group leaders',
    513330: 'Group data not found',
    513331:
      'There are active sub-accounts under your account. Please delete the sub-accounts before canceling the current account',
    513332:
      'You have not bound a mobile phone number yet. To protect your rights and interests, please log in to the web version to bind your mobile phone number before proceeding with the operation!',
    513333: 'Failed to update group status',
    513341: 'Video polling function has been enabled',
    513342:
      'Your number of co-hosts has reached the upper limit. The video polling function cannot be enabled temporarily. You can take the audience off the mic before enabling the video polling function',
    513343: 'Video polling is not enabled',
    513344: 'No permission',
    513345: 'You are in the polling process and cannot go on the mic temporarily',
    513346:
      'This audience is in the polling process and cannot go on the mic temporarily. Please try again later',
    513350: 'Number cannot be empty or exceed the range of online users',
    513370: 'Incorrect format of document watermark type',
    513371: 'The number of characters in the fixed text of the document watermark exceeds 20',
    513390: 'The uploaded document key does not exist',
    513391: 'File detection failed or the selected template is incorrect, please try again',
    513402: 'When global mute is enabled, chat mute cannot be set to off',
    513405: 'Failed to delete camera position',
    513407: 'Camera position does not exist',
    513410: 'Camera position already exists',
    513420: 'Failed to set camera position status',
    513421: 'Mobile phone number is required',
    513422: 'Mobile phone number with verification code is required',
    513423: 'Token expired or does not exist, please try again',
    513424: 'No invalid files detected',
    513425: 'Incorrect verification code',
    513426: 'Abnormal data of participating users',
    513500: 'Incorrect data format for file download',
    513501: 'Survey not submitted',
    513502: 'Unique download identifier does not exist',
    513503: 'Data does not exist or has been deleted',
    513504: 'Exception occurred while generating download address',
    513505: 'Please select a survey',
    513506: 'A maximum of 50 data entries can be added',
    513507: 'The organizer has updated the survey, please fill it out again',
    513508: 'Insufficient viewing duration',
    513509: 'Please select viewing duration',
    513510: 'Viewing duration exceeds the limit',
    513532: 'Cannot use interactive mic connection related functions.',
    513533: 'Interactive token missing',
    513534: 'Activity type mismatch,operation prohibited.',
    513535: 'Failed to obtain host information.',
    513536: 'Activity mismatch.',
    513537: 'Current user does not have permission',
    513538: 'Failed to obtain participant user information.',
    513539: 'Upload failed when importing file.',
    513540: 'No data available for export.',
    513541: 'File export error.',
    513542: 'Participant role permission level too low.',
    513543: 'Please contact administrator to activate permission.',
    513544: 'Please upload materials.',
    513545: 'The sub-account can only obtain data under its own account',
    513546: 'Obtaining key cannot be empty.',
    513547: 'open_id acquisition failed.',
    513548: 'The reward amount exceeds the limit',
    513549: 'Uploaded document is too large',
    513550: 'Invalid image path.',
    513551: 'Duplicate setting of group leader',
    513552: 'Privacy agreement format is incrrect.',
    513553:
      'The preview word count is exceeded when adding the privacy agreement; please delete some content and try again',
    513554: 'The value of statement_content must contain the title value from statement_info',
    513555: 'There is no preset group in the whitelist;',
    513556: 'Only the host role can be set as the effective role for group live streaming',
    513560: 'Number of joint microphones not configured',
    513561: 'Please enter the correct group number.',
    513562: 'Group member count reaches maximum limit of 2000!.',
    513563: 'A maximum of 200 entries are supported for batch export',
    513564: 'The number of whitelists under the account exceeds the limit',
    513570: 'Global mute is enabled; modification is not allowed!',
    513600: 'The screen pushing card does not exist',
    513601: 'Operation is prohibited during pushing',
    513602: 'A maximum of 200 cards are supported',
    513603: 'A maximum of 200 cards are supported',
    513611: 'The audience already exists; duplicate addition is not allowed',
    513621: 'Please associate the live room first',
    513622: 'The upper limit of participants must be an integer multiple of 100',
    513623: 'Already published; cannot be published again',
    513625: 'A binding relationship already exists; please reset first before binding again',
    513626: 'The binding relationship does not exist',
    513631: 'The developer information does not exist;',
    513632: 'User is not authorized',
    513633: 'Invalid token.',
    513641: 'Invalid token.',
    513642: 'Invalid token.',
    513643: 'Invalid token.',
    513650: 'The cash gift opening conditions are not met',
    514000: 'Maximum 1000 emails allowed at a time.',
    514001: 'Invalid email address.',
    514002: 'Missing query id.',
    514003: 'Missing download address.',
    514004: 'Current upload type contains prohibited type',
    514005: 'Current upload type not allowed',
    514006: 'Upload path contains special characters',
    514007: 'Uploaded file does not exist',
    514008: 'Uploaded file cannot exceed 4M',
    514009: 'End time cannot be earlier than start time.',
    514010: 'Incorrect time format.',
    514011: 'Email sending failed.',
    514012: 'Download center generation missing necessary parameters.',
    514013: 'Please include https! When regenerating url.',
    514014: 'Authorization failed, please refresh and try again',
    514015: 'File upload failed, please try again',
    514021: 'Creation failed.',
    514022: 'Modification failed.',
    514023: 'The version in use cannot be taken off the shelf',
    514061: 'No active version.',
    514062: 'system_type cannot be empty.',
    514063: 'Illegal access.',
    514064: 'App En name already exists!',
    514065: 'bundle_id already exists!',
    514401: 'System busy, please try again later.',
    515000: 'Camera position is already occupied',
    515001: 'Document service call exception.',
    515002: 'User token has expired.',
    515003: 'Illegal user token.',
    515200: 'Activity does not exist or is not an H5 activity',
    516000: 'Unknown error.',
    516001: 'Illegal access.',
    516002: 'User does not exist.',
    516003: 'Permission verification failed.',
    516004: 'System busy, please try again later.',
    516005: 'Signature verification failed.',
    516006: 'Activity does not exist.',
    516007: 'Current interface can only be accessed once every 30 seconds!.',
    516016: 'Webinar has not started.',
    516017: 'Activity not in replay',
    516026: 'Room status mismatch.',
    516101:
      'Remaining valid time of current package is less than one month, upgrade not supported.',
    516103: 'Order deletion failed!.',
    516104: 'Unlimited package cannot purchase other packages.',
    516105: 'User type error.',
    516106: 'Upgraded concurrency must be greater than current concurrency.',
    516107: 'Unactivated concurrency package exists.',
    516108: 'You have pending orders, cannot add new ones temporarily.',
    516109: 'No upgradable packages available;',
    516110: 'Incorrect traffic-based purchase quantity',
    516111: 'package type error.',
    516112: 'You have no arrears.',
    516113: 'Incorrect number of people entered for extension package.',
    516114: 'Arrears type error.',
    516115: 'Order does not exist.',
    516117: 'Payment callback processing failed.',
    516118: 'Order status exception.',
    516119: 'Sub-account cannot operate.',
    516120: 'This account is a sub-account, cannot add new packages/resources.',
    516121: 'Please clear arrears first.',
    516123: 'Please clear playback traffic arrears first.',
    516126: 'This account is a parent account, cannot add infinite package!',
    516127: 'Allocation quantity cannot exceed available quantity!.',
    516128: "Package end time can't be earlier than current time!",
    516145: 'Concurrent range is 1 to 99999 people.',
    516149: 'Operator id does not exist.',
    516150: 'New paid user creation failed.',
    516151: 'Order type error.',
    516200: 'Activity does not exist or is not an h5 activity.',
    516201: 'Failed to load basic activity data',
    516202: 'Failed to load provincial statistics',
    516203: 'Device statistics error',
    516204: 'Browser statistics error',
    516205: 'Viewership trend error',
    516206: 'Concurrent trend error',
    516207: 'Max concurrent error',
    516208: 'Viewing details error',
    516209: 'Activity heat error',
    516210: 'Basic statistics error',
    516211: 'Failed to get online users',
    516212: 'Online users query error',
    516213: 'API viewing details error',
    516214: 'Account max concurrent error',
    516215: 'Account duration error',
    516216: 'Activity max concurrent error',
    516217: 'Traffic usage statistics error',
    516218: 'Activity count exceeds limit',
    516219: 'Account creation time is empty',
    516220: 'Invalid query time range',
    516223: 'Invalid query time range',
    516224: 'Invalid query time',
    516300: 'Please bind mobile phone number first.',
    516301: 'Verification code verification failed',
    516302: 'concurrency prepaid package cannot purchase extension package.',
    516303: 'Account with sub-accounts cannot purchase extension package.',
    516304: 'Order has expired.',
    516305: 'Sms verification code verification failed.',
    516306: 'Please bind wechat first.',
    516307: 'Cash-out amount cannot be less than 1 yuan.',
    516308: 'Cash-out amount cannot exceed balance.',
    516309: 'Traffic user arrears exceed 100g',
    516310: 'concurrency expired',
    516311: 'concurrent users exceed limit',
    516312: 'you have a pending cash-out.',
    516313: 'Exceeds maximum online single cash-out limit, please use offline cash-out process.',
    516314: 'Download center request failed.',
    516315: 'Oss upload failed.',
    516316: 'Export file generation failed.',
    516317: 'Batch initialization of sub-account paid members exception.',
    516318: 'Exceeds allocable resources.',
    516319: 'Sub-account resource allocation operation exception.',
    516320: 'Sub-accounts not belonging to parent account exist.',
    516321: 'Dear member, you have traffic arrears',
    516322: 'dear member, your traffic has been exhausted',
    516323: 'dear member, you have extension package arrears',
    516324: 'dear member, your concurrency package has expired.',
    516325: 'Order generation failed.',
    516326: 'Export file being generated.',
    516327: 'Mandatory fields cannot be empty.',
    516328: 'Failed to query order payment details.',
    516329: 'Dear member, your duration has run out. Please recharge.',
    516330: 'Dear member, your duration is overdue. Please recharge.',
    516331: 'Event is full. Capacity limit reached.',
    516500:
      'Package resource package initialization only supports [traffic package; concurrency package; concurrency prepaid package]',
    516501: 'resource package type exception.',
    516502: 'Current user is a non-paying user',
    516503: 'user package does not exist or has expired.',
    516504: 'No valid packages available',
    516505: 'infinite edition can only add playback traffic-based package.',
    516506: 'Illegal resource package.',
    516507: 'Conflicting resource package already exists.',
    516508: 'Resource package saving exception.',
    516509: 'Parent account does not support this resource package.',
    516510: 'Package resource binding relationship addition exception.',
    516511: 'Resource package valid time cannot exceed package valid time.',
    516512: 'Conflicting package already exists within package period.',
    516513: 'Resource package conflicts with billing type.',
    516514: 'Please select the correct concurrency prepaid package to calculate peak value.',
    516515: 'Resources and amount cannot be negative.',
    516516: 'Login status invalid.',
    516517: 'Function version does not exist.',
    516518: 'Resource package does not exist.',
    516519: 'Only infinite edition users can add.',
    516520: 'Paid user already exists.',
    516521: 'Registered user trial package initialization failed.',
    516522: 'Paid member does not exist.',
    516523: 'This user is not a sub-account.',
    516524: 'Source does not exist.',
    516525: 'Not a new package, operation unavailable. Please convert old package first.',
    516526: 'Contact support to upgrade package or purchase in old console.',
    516527: 'Company not filled, operation unavailable.',
    516528: 'No assigned sales, operation unavailable.',
    516529: 'No active package resources available.',
    516530: 'Either phone or email is required.',
    516531: 'Cannot exceed current available resources.',
    516532: 'User not bound to Official Account',
    516604: 'Prize creation/saving failed.',
    516605: 'Room id/activity id is mandatory when source is 0.',
    516606: 'Activity does not exist or has been deleted.',
    516607: 'External interface call error.',
    516701: 'Uploaded file does not exist or is incorrect.',
    516702: 'Lucky draw page not set up yet.',
    516703: 'Lucky draw has ended.',
    516708: 'You have already participated.',
    516709: 'Lucky draw type error.',
    516710: 'Lucky draw in progress, cannot initiate again.',
    516711: 'Password cannot be empty for password lottery.',
    516712: 'Preset winner verification failed.',
    516713: 'Your role cannot initiate lottery.',
    516714: 'Your role operation is illegal.',
    516715: 'Set number of winners cannot exceed eligible winners.',
    516716: 'Parameter verification failed,',
    516719: 'Failed to obtain user wechat openid.',
    516720: 'No payment required for this activity.',
    516721: 'You have no this permission.',
    516722: 'Lucky draw does not exist.',
    516723: 'Winner information not found.',
    516724: 'Parameters cannot contain emoji or special characters',
    516725: 'Prize name cannot contain emoji or special characters',
    516726: 'Prize quantity cannot exceed 20.',
    516727: 'Activity id cannot be empty.',
    516728: 'Failed to call universal lottery service',
    516729: 'Prize does not exist',
    516730: 'Lottery deleted',
    516731: 'Please push check-in first',
    516732: 'Please push specified questionnaire first',
    516733: 'Please push the Fast Q&A first',
    516734: 'Quick Q&A score not calculated yet',
    516735: 'Insufficient prizes',
    516736: 'Only ongoing lottery can be ended',
    516737: 'Max 2000 prizes allowed',
    516738: 'Lottery can be pushed only after live starts',
    516739: 'Lottery pushed, cannot edit',
    516740: 'Failed to set prize snapshot',
    516741: 'Cannot delete ongoing lottery',
    516742: 'Lottery ended, cannot restart',
    516743: 'No check-in permission',
    516744: 'No questionnaire permission',
    516745: 'No quick Q&A permission',
    516746: 'No audience group permission',
    516747: 'Specified questionnaire deleted, cannot push lottery',
    516748: 'Specified quick Q&A deleted, cannot push lottery',
    516749: 'Please push the survey first',
    516750: 'Prize already claimed',
    516751: 'Scheduled lottery countdown cannot be 0',
    516752: 'Lottery ending, no repeated operations',
    516753: 'Interactive reward record not found',
    516754: 'Coupon prize cannot be copied',
    516755: 'Failed to request product service',
    516756: 'Failed to request callback service',
    516757: 'Lottery already pushed, no repeat push',
    516758: 'Lottery not pushed, cannot end',
    516759: 'Activity ID mismatch',
    516801: 'Failed to obtain PAAS ticket',
    516802: 'Room mismatch.',
    516803: 'Invalid survey.',
    516804: 'No operation permission.',
    516805: 'Already participated.',
    516806: 'Form copying failed.',
    516807: 'Too many surveys under the room.',
    516808: 'User has not participated.',
    516809: 'User has already answered the survey.',
    516810: 'Answer parameter exception.',
    516811: 'This user does not exist.',
    516812: 'Room id parameter error.',
    516813: 'Authentication exception.',
    516814: 'Sub-account information does not exist.',
    516815: 'This activity is not a sub-account activity under the parent account.',
    516816: 'Survey not found.',
    516817: 'Questions corresponding to this survey not found.',
    516818: 'Verification code sent, do not request frequently',
    516819: 'Failed to get SMS signature',
    516820: 'Cash-out amount cannot be less than 2 yuan.',
    516821: 'Please upload application form photo.',
    516822: 'Uploaded application form photo format error.',
    516823: 'The user has a pending offline cash-out being added.',
    516824: 'Cash-out application amount cannot exceed user account balance.',
    516825: 'User account balance is less than 0 yuan.',
    516826: 'Sms verification code sending failed.',
    516827: 'Offline cash-out type can only be live stream and red packet earnings.',
    516828: 'An order is being processed, please process it before adding a new offline cash-out.',
    516829: 'Cash-out and transfer failed.',
    516830: 'This is not a parent account',
    517218: 'Failed to get lottery homepage info',
    517219: 'Failed to get room questionnaire list',
    517220: 'Failed to load questionnaire question details',
    517221:
      'Resource parameter value exception (traffic must be positive & concurrency must be a positive integer).',
    517222: 'Resource value cannot exceed 2 decimal places',
    518001: 'Interactive reward not found!',
    518002: 'Questionnaire is bound, please check',
    518003: 'Winners exist, operation not allowed',
    518004: 'Winners exist, cannot delete',
    518005: 'Gift not found',
    518006: 'Questionnaire pushed, cannot delete',
    518007: 'Please select a questionnaire',
    518008: 'Failed to batch create gifts',
    518100: 'View reward not found!',
    518101: 'Already joined this view reward!',
    518102: 'View duration requirement not met!',
    518103: 'No prize to claim!',
    518104: 'View reward not found or not pushed!',
    518105: 'Account offline, cannot join view reward!',
    518106: 'Cannot edit prize unless in draft state',
    518107: 'View reward pushed, operation not allowed',
    518108: 'Please add the prize receiving configuration',
    518109: 'Failed to get lottery strategy',
    518111: 'Max 1000 per activity',
    519001: 'AI chat topic not found',
    519002: 'No nickname added!',
    519003: 'No comment content added!',
    519004: 'Upload limit reached!',
    519005: 'Topic being pushed, cannot edit',
    519006: 'Topic being pushed, operation not allowed',
    519007: 'Chatbot not found',
    519008: 'Chatbot contains special characters',
    519009: 'Chatbot cannot be empty',
    519010: 'Message type not supported',
    519011: 'Quick message not found',
    519012: 'Default quick message cannot be edited',
    519013: 'Quick message limit exceeded',
    519014: 'Quick message already exists',
    520001: 'Mall reward not found',
    520002: 'Mall reward operation not allowed',
    520003: 'Mall reward pushed, operation not allowed',
    520004: 'Only manual push allowed',
    520005: 'Reward not set, please check',
    520006: 'Other reward being pushed',
    520007: 'Mall reward not pushed',
    520008: 'Reward already claimed',
    520009: 'Create count exceeds limit',
    520010: 'View duration already exists, please reselect',
    520011: 'Selectable reward limit exceeded',
    520012: 'Insufficient view duration to claim',
    520013: 'Batch edit count exceeds limit',
    520014: 'Prize ID cannot be empty',
    520015: 'Prize ID cannot be duplicate',
    520098: 'Mall reward ended',
    520099: 'Reward fully claimed',
    521001: 'Failed to call universal reward service',
    530002: 'Activity does not exist',
    530006: 'File upload failed',
    530007: 'Creation failed.',
    530008: 'Product creation parameter missing',
    530021: 'Order information has changed, please close this pop-up and place the order again',
    530022: 'Pre-order creation failed',
    530023: 'Payment system exception',
    530024: 'Order does not exist',
    530025: 'Order callback signature verification failed',
    530026: 'External link products do not support ordering',
    530027: 'Product is missing the APP purchase template link',
    530028: 'signature error',
    530029: 'Mixed purchase types are not supported',
    530030: 'Only one type of product can be purchased',
    530031: 'Corresponding payment link not found',
    530032: 'Order submission is too frequent,please try again later',
    530033: 'Product does not exist or has been removed from shelves',
    530034: 'Payment system call timed out',
    530035: 'User coupon does not exist',
    530036: 'User coupon has been used or expired',
    530037: 'This coupon is not applicable to non-designated products',
    530038: 'This coupon is not applicable to this product',
    530039: 'Ordered product mismatch',
    530040: 'Product price has not been set, purchase is not allowed',
    530041: 'Order number already exists',
    530071: 'Merchant number is not bound yet',
    530072: 'Product operation failed',
    530073: 'Duplicate product addition',
    530091: 'Activity product creation exceeds the limit',
    530092: 'Product ID cannot be empty or null',
    530093: 'Activity product operation failed',
    530094: 'Activity product does not exist or is not on shelves',
    531000: 'User count cannot exceed current',
    531001: 'Data subscription rule not found',
    531002: 'Data subscription rule count exceeds limit',
    531003: 'Duration subscription rule: invalid condition',
    531004: 'Duration subscription rule: start duration too short',
    531005: 'Duration subscription rule: min interval too short',
    531006: 'Duration subscription rule: cycle too long',
    532001: 'Unsupported payment method',
    532002: 'Order amount cannot be modified',
    532004: 'Order does not exist or the order number does not match the appId',
    532005: 'Third-party order creation failed, please contact the developer',
    532006: 'Order has been paid, cannot apply for payment again',
    532007: 'Payment method parameters are not configured',
    532008: 'WeChat order creation failed',
    532009: 'Parameter error returned when obtaining WeChat payment parameters',
    532010: 'Order closing failed',
    532011: 'Order query failed',
    532012: 'Payment method cannot be changed',
    532013: 'Certificate file initialization failed',
    532014: 'Order already exists',
    532015: 'Incorrect merchant configuration corresponding to the service provider',
    532016: 'Merchant type mismatch',
    532017: 'Merchant transfer scenario mismatch',
    532018: 'Transfer order already exists',
    532019: 'Transfer order does not exist',
    532020: 'Incorrect transfer order status',
    530018: 'Exception occurred when setting activity product status',
    530010: 'Pre-sale product not found',
    530011: 'Auto-pop-up product not found',
    540000: 'Coupon does not exist',
    540001: 'Coupon under the activity does not exist',
    540002: 'Coupon has been deleted!',
    540003: 'Product has expired!',
    540004: 'The number of coupons under the activity cannot exceed 200!',
    540005: 'Incorrect UID of the user to whom the coupon belongs',
    540006: 'Coupon has expired',
    600000: 'Cannot activate package: sub-account exists or permitted',
    600001: 'Duration package not supported on Unlimited edition',
    600002: 'Over max resource limit',
    600003: 'Only Huadie migrated users (no Flash) allowed',
    600004: 'Pending Flash activities exist',
    600005: 'Resource pack cannot be voided',
    600006: 'Package exhausted, please recharge',
    600007: 'Enter positive integer < current balance',
    600010: 'Highlight clip does not exist',
    600011: 'Highlight clip creation failed',
    600012: 'Highlight clip creation in progress',
    600020: 'Summary does not exist',
    600021: 'Summary cannot be edited',
    600030: 'Highlight moment does not exist',
    600031: 'Highlight moment cannot be edited',
    600040: 'Intelligent subtitle does not exist',
    610001: 'File does not exist',
    614000: 'User does not have permission to access this data',
    614001: 'Invalid client parameter',
    614002: 'Parameter verification failed, please check',
    614003: 'Data processing failed',
    614004: 'Not a group live stream, cannot send group announcement',
    614200: 'Cannot delete document while document activity is live!',
    614201: 'Document does not exist!',
    614202: 'Document already synced!',
    614203: 'webinar_id does not match document id!',
    614204: 'Incorrect OSS address parameter for document upload!',
    614205: 'Message has been deleted or does not exist!',
    615000: 'Invalid role',
    618000: 'Service request failed',
    618100: 'Incorrect parameter for sending chat message',
    620001: 'Intelligent parsing does not exist',
    620002: 'Intelligent parsing incomplete',
    620004:
      'Current video duration is less than 3 minutes, please select another video for parsing',
    620005: 'Creating in progress, please wait patiently',
    620006: 'Creation failed, please create again',
    620007: 'Correction completed, cannot edit',
    620010: 'Highlight clip does not exist',
    620011: 'Highlight clip creation failed',
    620012: 'Highlight clip being generated',
    620020: 'Summary does not exist',
    620021: 'Summary cannot be edited',
    620030: 'Highlight moment does not exist',
    620031: 'Highlight moment cannot be edited',
    620040: 'Intelligent subtitle does not exist',
    650000: 'Image size cannot exceed 10M',
    650001: 'Red packet pushed, operation not allowed',
    650002: 'Red packet count must be greater than 0',
    650003: 'Cash red packet not found!',
    650004: 'Cash red packet pushed, cannot repeat push',
    650005: 'Cash red packet error, please reconfigure',
    650006: 'Cash red packet not pushed, cannot end',
    650007: 'Cash red packet ended',
    650008: 'Cash red packet fully claimed',
    650009: 'Insufficient cash red packet amount',
    650010: 'Red packet restrictions not met',
    650011: 'Cash red packet amount too small',
    650012: 'Only unlimited red packets can be pushed manually',
    650013: 'Only scheduled red packets supported in replay',
    650014: 'All red packets pushed, operation not allowed',
    650016: 'Cash red packet deleted, cannot claim',
    650017: 'Red packet claim time expired',
    650018: 'Not joined red packet activity',
    650019: 'Room not in replay state',
    650020: 'Claim failed, cannot claim again',
    650021: 'Only one red packet can be sent at a time',
    650022: 'Already claimed this red packet',
    650023: 'Cash red packet deleted',
    650024: 'The red packet opening conditions are not met',
    650025: 'Switch cannot be enabled during live stream',
    801304: 'Failed to bind channel, operation not allowed',
    5100016: 'Do not send repeated requests in a short period of time',
    5100017: 'Creation failed.',
    5100018: 'Update failed.',
    5100019: 'Data does not exist.',
    5100230: 'This operation is not allowed during live stream',
    5100231: 'Do not send repeated requests in a short period of time',
    5100232: 'The organizer has enabled "WeChat Mandatory Login"',
    5100233: 'No permission for this function',
    5100236: 'No operation permission for the management terminal!',
    5120026: 'Number of data entries exceeds the limit',
    5136001: 'There are no available videos currently',
    5513334: 'Group creation failed',
    5513335: 'Mobile users are not supported to promote group leaders temporarily',
    5513336: 'The group has not been initialized; this interface cannot be called',
    5513337: 'This configuration is not supported for group live streaming',
    8010000: 'CorpId cannot be empty',
    8010001: 'CorpId does not exist',
    8010002: 'CorpUserId cannot be empty',
    8010003: 'Authorization information does not exist',
    8010004: 'Only C-side users are supported',
    8010005: 'Enterprise information does not exist',
    8010006: 'Enterprise information is abnormal',
    8010007: 'Signature verification failed',
    8010008: 'Signature-generated URL cannot be empty',
    8010009: 'Failed to obtain application token',
    8010010: 'Failed to obtain supplier token',
    8010011: 'Failed to obtain enterprise token',
    8010012: 'Failed to obtain enterprise pre-authorization code',
    8010013: 'Failed to obtain accessing user identity via enterprise internal application',
    8010014: 'Failed to obtain permanent authorization code and enterprise information',
    8010015: 'Failed to obtain department list',
    8010016: 'Failed to obtain department member details',
    8010017: 'Failed to batch obtain customer details',
    8010018: 'Failed to obtain customer details',
    8010019: 'Failed to obtain accessing user identity',
    8010020: 'Failed to obtain user sensitive information',
    8010021: 'Failed to obtain app jsapi_ticket from WeChat',
    8010022: 'Failed to obtain enterprise jsapi_ticket',
    8010023: 'Failed to convert enterprise subject unionId to external contact id',
    8010024: 'Failed to convert third-party subject unionId to external contact id',
    8010025: 'Interoperable account expired,need to purchase activation code for activation',
    8010026: 'Failed to read member information',
    8010027: 'Failed to create contact me',
    8010028: 'Failed to delete contact me',
    8010029: 'Not an enterprise member or enterprise customer',
    8010030: 'Enterprise member information does not exist',
    8010050: 'Failed to obtain official Account ticket',
    8010100: 'SSO registration failed',
    8010101: 'SSO token verification failed',
    8010102: 'Mobile number is not registered',
    8010103: 'Mobile number is already registered',
    8010104: 'Email address is not registered',
    8010105: 'Email address is already registered',
    8010106: 'Account is already registered',
    8010107: 'token has expired',
    8010108: 'token has been logged out',
    8010109: 'Incorrect user type',
    8010110: 'Account does not exist',
    8010111: 'Password is incorrect',
    8010112: 'Failed to send verification code',
    8010113: 'Verification code is invalid',
    8010114: 'Vhall Cloud resources not configured',
    8010115: 'SMS template not configured',
    8010116: 'Verification code has been sent',
    8010117: 'User has been disabled',
    8010118: 'Email template configuration does not exist',
    8010120: 'Avatar is illegal',
    8010121: 'Uploaded image is too large',
    8010122: 'Uploaded file type is not supported',
    8010123: 'Third-party account and password mismatch',
    8010124: 'Do not send repeated requests in a short period of time',
    8010125: 'Mobile number already exists',
    8010126: 'Email address already exists',
    8010127: 'Authorization check failed',
    8012000: 'User information parameter missing',
    8012001: 'Query condition is empty',
    8012002: 'Saving failed.',
    8012003: 'No invitation sending record found by invitation code',
    8012004: 'Maximum number of custom templates is 5',
    8012005: 'System error, please try again later',
    8012006: 'Please select 1 invitation card to be in display status',
    8012007: 'Incorrect activity information',
    8012008: 'B-side user ID cannot be empty',
    8013001: 'Both channel name and channel code are duplicated',
    8013002: 'Parameter [channel_ids] cannot be empty',
    8013003: 'Failed to delete channel',
    8013005: 'Contains unbound channels',
    8013006: 'Contains bound channels',
    8013007: 'Maximum 200 channels can be created',
    8013009: 'Channel name duplicated',
    8013010: 'Channel code duplicated',
    8013011: 'scene_type cannot be empty',
    8014000: 'No corresponding traffic diversion configuration found',
    8014011: 'No hosted official account information found',
    8014012: 'Invalid hosted official account status',
    8014013: 'Remote call failed',
    8014014: 'Authorization timed out',
    8014015: 'Lack of refresh token',
    8014016: 'Abnormal authorization status of default official account',
    8014017: 'Failed to obtain authorization',
    8014020: 'component_appid not found',
    8014021: 'Failed to generate pre-authorization code',
    8014022: 'Invalid authorization status',
    8014023: 'Invalid usage',
    8014024: 'Refresh authorizer token failed',
    8014030: 'Failed to create QR code with parameters',
    8014100: 'Not the actual owner',
    8014101: 'Not a valid URL',
    8014102: 'page_path cannot start or end with /',
    8014103: 'Failed to generate mini-program code',
    8014104: 'Mini-program login failed',
    8015001: 'Query condition is empty',
    8015002: 'Tag name already exists',
    8015003: 'No data found',
    8015004: 'Tag is already pinned',
    8015005: 'Tag is not pinned',
    8015006: 'Tag is already marked',
    8015007: 'Tag does not exist',
    8015008: 'Platform-level tags cannot be modified',
    8015009: 'Only tags created by yourself can be modified',
    8015010: 'Category name already exists',
    8015011: 'When sorting up, the record ID below cannot be empty',
    8015012: 'When sorting down, the record ID above cannot be empty',
    8015013: 'Batch name modification not allowed',
    8015014: 'Tags do not support cross-tenant updates',
    8015015: 'Tag category does not exist',
    8015016: 'Batch query cannot exceed 100 items at a time',
    8015017: 'B tenant does not exist',
    8015018: 'sourceType conversion exception',
    8019000: 'Form information does not exist',
    8019001: 'Form has been deleted',
    8019002: 'No form question information found',
    8019003: 'Form information does not exist',
    8019020: 'Form binding relationship does not exist',
    8019040: 'Invalid form answer information',
    8019041: 'Form answer already exists',
    8020000: 'Notification configuration information does not exist',
    8020002: 'Notification configuration information mismatch',
    8020003: 'Sending time type mismatch',
    8020004: 'Notification template does not exist',
    8020005: 'Notification has been sent, template modification not allowed',
    8020006: 'Sent time cannot be deleted',
    8020007: 'Custom sending time cannot be duplicated',
    8020008: 'Relative sending time cannot be duplicated',
    8020009: 'Invalid notification type',
    8020010: 'Default template cannot be deleted',
    8020011: 'SMS signature cannot be duplicated',
    8020012: 'SMS signature update exception',
    8020013: 'System error, please try again later',
    8020014: 'Activity information does not exist',
    8020015: 'Appointment/registration time modification not supported',
    8020016: 'This template does not support setting relative time',
    8020017: 'WeChat template addition failed',
    8020018: 'WeChat notification template not set',
    8020019: 'SMS signature does not exist',
    8020020: 'SMS signature already in use, do not repeat operation',
    8020021: 'Default SMS signature cannot be deleted'
  },
  el: {
    colorpicker: {
      confirm: 'OK',
      clear: 'Clear'
    },
    datepicker: {
      now: 'Now',
      today: 'Today',
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      endDate: 'End Date',
      endTime: 'End Time',
      prevYear: 'Previous Year',
      nextYear: 'Next Year',
      prevMonth: 'Previous Month',
      nextMonth: 'Next Month',
      year: '',
      month1: 'January',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      week: 'week',
      weeks: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat'
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec'
      }
    },
    select: {
      loading: 'Loading',
      noMatch: 'No matching data',
      noData: 'No data',
      placeholder: 'Select'
    },
    cascader: {
      noMatch: 'No matching data',
      loading: 'Loading',
      placeholder: 'Select',
      noData: 'No data'
    },
    pagination: {
      goto: 'Go to',
      pagesize: '/page',
      total: 'Total {total}',
      pageClassifier: ''
    },
    messagebox: {
      title: 'Message',
      confirm: 'OK',
      cancel: 'Cancel',
      error: 'Illegal input'
    },
    upload: {
      deleteTip: 'press delete to remove',
      delete: 'Delete',
      preview: 'Preview',
      continue: 'Continue'
    },
    table: {
      emptyText: 'No Data',
      confirmFilter: 'Confirm',
      resetFilter: 'Reset',
      clearFilter: 'All',
      sumText: 'Sum'
    },
    tree: {
      emptyText: 'No Data'
    },
    transfer: {
      noMatch: 'No matching data',
      noData: 'No data',
      titles: ['List 1', 'List 2'], // to be translated
      filterPlaceholder: 'Enter keyword', // to be translated
      noCheckedFormat: '{total} items', // to be translated
      hasCheckedFormat: '{checked}/{total} checked' // to be translated
    },
    image: {
      error: 'FAILED'
    },
    pageHeader: {
      title: 'Back' // to be translated
    },
    popconfirm: {
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    },
    empty: {
      description: 'No Data'
    }
  }
};
